// extracted by mini-css-extract-plugin
export default {"wrapper":"CallContacts_wrapper__FVZGW"};